import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProperty } from 'src/pages/Reporting/ReportingFormTypes';

interface SidebarPermissionsState {
  allowedTabList: any[];
  properties: IProperty[];
  orders: any[];
  orderDetails: any;
  keyContacts: any[];
  hasFetched: boolean;
}

const initialState: SidebarPermissionsState = {
  allowedTabList: [],
  properties: [],
  orders: [],
  orderDetails: null,
  keyContacts: [],
  hasFetched: false,
};

const sidebarPermissionsSlice = createSlice({
  name: 'sidebarPermissions',
  initialState,
  reducers: {
    setSidebarPermissions: (
      state,
      action: PayloadAction<Omit<SidebarPermissionsState, 'hasFetched'>>
    ) => {
      state.allowedTabList = action.payload.allowedTabList;
      state.properties = action.payload.properties;
      state.orders = action.payload.orders;
      state.orderDetails = action.payload.orderDetails;
      state.keyContacts = action.payload.keyContacts;
      state.hasFetched = true;
    },
    // Must be dispatched on logout to prevent stale permissions
    // being shown if a different user logs in on the same browser session.
    clearSidebarPermissions: () => initialState,
  },
});

export const { setSidebarPermissions, clearSidebarPermissions } = sidebarPermissionsSlice.actions;
export default sidebarPermissionsSlice.reducer;